/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useState, useMemo } from "react";
// import { css } from "@emotion/react";
import { css } from "aphrodite";
import { useNavigate } from "react-router-dom";
import DropDownSelect from "../../components/common/Dropdown/index";
import {
  MONTHS_OPTIONS,
  YEARS_OPTIONS,
  getCurrentMonth,
  getPreviousMonth,
  getCurrentYear,
} from "../../utils/dateAndTime";
import Typography from "../../components/common/new/Typography/Typography";
import InputField from "../../components/common/new/InputField/InputField";
import Colors from "../../theme/colors";
import Styles from "./styles";
import { isEmptyObj } from "../../utils/helper";
import Button from "../../components/common/Button";

function AttendanceHeaderForMobile({
  isArchive,
  attendanceList,
  meetings,
  otherAttendeesCount,
  onChangeOtherAttendeesCount,
  selectedMeetingType,
}) {
  const [month, setMonth] = useState(() =>
    isArchive ? getPreviousMonth(getCurrentMonth()) : getCurrentMonth(true)
  );
  const [year, setYear] = useState(getCurrentYear());
  const isGivenIdPresent = (id) => attendanceList.includes(id);
  const navaigate = useNavigate();

  const [presentFriends, presentLeaders, presentMembers, presentNewFriends] =
    useMemo(() => {
      if (meetings && !isEmptyObj(meetings)) {
        return [
          meetings?.friends?.length
            ? meetings?.friends.filter((item) =>
                isGivenIdPresent(item.friendId)
              ).length
            : 0,
          meetings?.leaders?.length
            ? meetings?.leaders.filter((item) =>
                isGivenIdPresent(`${item.memberId}-L`)
              ).length
            : 0,
          meetings?.members?.length
            ? meetings?.members.filter((item) =>
                isGivenIdPresent(item.memberId)
              ).length
            : 0,
          meetings?.newFriends?.length
            ? meetings?.newFriends.filter((item) =>
                isGivenIdPresent(item.friendId)
              ).length
            : 0,
        ];
      }
      return [0, 0, 0, 0];
    }, [meetings, isGivenIdPresent]);

  // calculation
  const totalFriendsCount = meetings?.friends?.length ?? 0;
  const totalMembersCount = meetings?.members?.length ?? 0;
  const totalNewFriendsCount = meetings?.newFriends?.length ?? 0;
  const totalLeadersCount = meetings?.leaders?.length ?? 0;

  const totalMeetingCount =
    totalFriendsCount +
    totalMembersCount +
    totalNewFriendsCount +
    totalLeadersCount;

  const presentTotalMeetingCount =
    presentFriends +
    presentLeaders +
    presentMembers +
    presentNewFriends +
    Number(otherAttendeesCount);

  const onAddNewFriendClick = () => {
    navaigate("/friends/new-friend/search");
  };

  return (
    <Box className={css(Styles.nonStickyBanner)}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          marginBottom: "12px",
        }}
      >
        <Typography
          sx={{
            fontSize: "11px",
            fontWeight: 600,
            color: "#8F92A1",
            letterSpacing: "0.5px",
            textTransform: "uppercase",
          }}
        >
          Meeting Type
        </Typography>

        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            padding: "6px 10px",
            borderRadius: "6px",
            backgroundColor: "#EEF2FF",
            border: "1px solid #C7D2FE",
            width: "fit-content",
            maxWidth: "100%",
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              color: "#3730A3",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {selectedMeetingType}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <DropDownSelect
          title="Month"
          label="Month"
          selectOptions={MONTHS_OPTIONS}
          value={month}
          setValue={setMonth}
          style={{ width: "100%", color: Colors.black }}
          disabled
        />
        <DropDownSelect
          title="Year"
          label="Year"
          selectOptions={YEARS_OPTIONS}
          value={year}
          setValue={setYear}
          style={{ width: "100%", color: Colors.black }}
          disabled
        />
      </Box>
      <Box item md={8} sm={12}>
        <Box className={css(Styles.searchContainer)}>
          <Box className={css(Styles.rightContainer)}>
            {" "}
            <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <Box
                style={{
                  background: "#424874",
                }}
                className={css(Styles.tilesForMobile)}
              >
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingLeft: "5px",
                  }}
                >
                  <Typography
                    style={{
                      color: "#FFF",
                      ...Styles.text,
                    }}
                    className={css(Styles.text)}
                  >
                    Member
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingLeft: "5px",
                  }}
                >
                  <Typography
                    style={{
                      color: "#FFF",
                      ...Styles.count,
                    }}
                    className={css(Styles.count)}
                  >
                    {presentMembers}/{totalMembersCount}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  background: "#CACFD6",
                }}
                className={css(Styles.tilesForMobile)}
              >
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingLeft: "5px",
                  }}
                >
                  <Typography
                    style={{
                      color: "#484848",
                      ...Styles.text,
                    }}
                    className={css(Styles.text)}
                  >
                    Leader
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingLeft: "5px",
                  }}
                >
                  <Typography
                    style={{
                      color: "#484848",
                      ...Styles.count,
                    }}
                    className={css(Styles.count)}
                  >
                    {presentLeaders}/{totalLeadersCount}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  background: "#A6B1E1",
                }}
                className={css(Styles.tilesForMobile)}
              >
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingLeft: "5px",
                  }}
                >
                  <Typography
                    style={{
                      color: "#454A61",
                      ...Styles.text,
                    }}
                    className={css(Styles.text)}
                  >
                    Friend
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingLeft: "5px",
                  }}
                >
                  <Typography
                    style={{
                      color: "#454A61",
                      ...Styles.count,
                    }}
                    className={css(Styles.count)}
                  >
                    {presentFriends}/{totalFriendsCount}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  background: "#DCD6F7",
                }}
                className={css(Styles.tilesForMobile)}
              >
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingLeft: "5px",
                  }}
                >
                  <Typography
                    style={{
                      color: "#484262",
                      ...Styles.text,
                    }}
                    className={css(Styles.text)}
                  >
                    New Friend
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingLeft: "5px",
                  }}
                >
                  <Typography
                    style={{
                      color: "#484262",
                      ...Styles.count,
                    }}
                    className={css(Styles.count)}
                  >
                    {presentNewFriends}/{totalNewFriendsCount}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  ...Styles.tiles,
                  background: "#436390",
                }}
                className={css(Styles.tilesForMobile)}
              >
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingLeft: "5px",
                  }}
                >
                  <Typography
                    style={{
                      color: "#FFF",
                      ...Styles.text,
                    }}
                    className={css(Styles.text)}
                  >
                    Total
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingLeft: "5px",
                  }}
                >
                  <Typography
                    style={{
                      color: "#FFF",
                      ...Styles.count,
                    }}
                    className={css(Styles.count)}
                  >
                    {presentTotalMeetingCount}/{totalMeetingCount}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <InputField
            label="Other Members"
            value={otherAttendeesCount}
            onChange={onChangeOtherAttendeesCount}
            style={isArchive ? { width: "100%" } : { width: "50%" }}
            disabled={isArchive}
          />
          {!isArchive && (
            <Button
              variant="contained"
              label="Add New Friend"
              style={{ width: "50%", height: "41px" }}
              onClick={onAddNewFriendClick}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default AttendanceHeaderForMobile;
